<template lang="pug">
	.container-fluid
		.row
			.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
				.card
					.card-header.bg-info.text-white
						span
						| Selecciona los ficheros para subir
					.table-responsive
						table.table.table-condensed.table-striped.m-0
							thead
								tr
									th(colspan="2")
										.input-group
											select.form-control(v-model="form.ID_buzon")
												option(:value="null") Selecciona buzón de destino
												option(v-for="buzon in listadoBuzones" :key="buzon.ID" :value="buzon.ID") {{ buzon.titulo }}
											.input-group-append
												button.btn.btn-primary(@click="seleccionarFicheros" :disabled="!form.ID_buzon")
													span.fa.fa-upload
							tbody
								tr(v-for="pendiente in pendientes" :key="pendiente.ID")
									td.text-left
										span.fa.fa-file.mr-2 {{ pendiente.fichero.name }}
										.mt-2(style="position:relative;display:block;")
											div(:style="{ width: pendiente.porcentaje + '%' }", style="position: absolute; display: block; left: 0; transition: width 300ms ease-out; height: 2px; background-color: darkred")
									td.text-right(style="width:30px;")
										button.btn.btn-sm.btn-danger
											span.fa.fa-trash
			.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-8
				.card
					.card-header.bg-warning.text-dark
						span
						| Ficheros actualmente en cola
					.table-responsive
						table.table.table-striped.m-0
							tbody 
								tr(v-for="fichero in listadoCola" :key="fichero.FicheroID" :class="(fichero.FechaSubido) ? 'text-success' : ''")
									td.text-left
										span.fa.fa-file.mr-2
										b {{ fichero.Fichero }}
										.mt-2(style="opacity:0.7;")
											span.fa.fa-calendar.mr-2 
											| Subido el {{ fichero.FechaCreado }} a las {{ fichero.HoraCreado }} por {{ fichero.nombre }} {{ fichero.apellidos }}
									td.text-right(style="vertical-align:middle;font-size:1.2em;")
										| {{ fichero.Buzon }}
										span.fa.fa-folder.ml-2
</template>
  


<script>

import API from './api'

export default {
	data () {
		return {
			form: {
				ID_buzon: null,
				ficheros: []
			},
			pendientes: [],
			contador: 0,
			listadoBuzones: [],
			listadoCola: [],
			handler: null
		}
	},

	created () {
		this.getBuzones()

		this.handler = window.setInterval(() => {
			this.getPendientes()
		}, 1000)

		this.getPendientes()
	},

	beforeDestroy () {
		window.clearInterval(this.handler)
	},

	methods: {
		getBuzones () {
			API.getBuzones()
				.then(res => {
					this.listadoBuzones = res.data.buzones
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		getPendientes () {
			API.getPendientes()
				.then(res => {
					this.listadoCola = res.data.ficheros
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		seleccionarFicheros () {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.multiple = true

			inp.addEventListener('change', (ev) => {
				const ficheros = ev.target.files

				for (let i = 0; i < ficheros.length; i++) {
					this.pendientes.push({
						ID: ++this.contador,
						ID_buzon: this.form.ID_buzon,
						fichero: ficheros[i],
						porcentaje: 0
					})
				}

				this.procesar()
			})

			document.body.appendChild(inp)

			inp.click()
		},

		procesar () {
			if (this.pendientes.length === 0) {
				return
			}

			const item = this.pendientes[0]

			const ajax = new XMLHttpRequest()
			ajax.open('POST', '/src/modulos/subir-xframe/php/upload.php')
			ajax.onreadystatechange = () => {
				if (ajax.readyState === 4) {
					if (ajax.status !== 200) {
						this.$store.commit('alertas/error', {
							titulo: 'Error',
							mensaje: 'Error subiendo el fichero'
						})
					}
					this.pendientes.splice(0, 1)
					this.procesar()
				}
			}

			ajax.upload.onprogress = (ev) => {
				if (ev.lengthComputable) {
					const total = ev.total
					const loaded = ev.loaded

					const porcentaje = Math.floor(loaded * 100 / total)
					item.porcentaje = porcentaje
				}
			}

			const form = new FormData()
			form.append('fichero', item.fichero)
			form.append('ID_buzon', item.ID_buzon)
			ajax.send(form)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/subir-xframe/vue/App.vue